// extracted by mini-css-extract-plugin
module.exports = {"container":"_1EYv9sguZPLaXz9m96RZ3g","charity":"YW-krUWaxNhxfFd0JVuRi","title":"_2jxQqOBrdulEtsM0D0HGmk","tag":"_120jUBWAac_fbGWk3yK7aU"};